import { PersistConfig, PersistedState } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { IAuthSlice } from '../types';
import { initialState } from '../store/authSlice';

const isAuthSlice = (state: unknown): state is IAuthSlice & PersistedState =>
  typeof state === 'object' && state !== null && 'callback' in state;

export const authPersistConfig: PersistConfig<IAuthSlice> = {
  key: 'auth',
  storage,
  // Only `callback` is ever restored (see `migrate` below). Keeping the rest
  // out of localStorage prevents the auth token from being readable via XSS
  whitelist: ['callback'],
  migrate: async state => {
    if (isAuthSlice(state)) {
      return {
        ...initialState,
        callback: state.callback || initialState.callback,
      } as IAuthSlice & PersistedState;
    }

    return state ?? (initialState as IAuthSlice & PersistedState);
  },
};
